import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_BASE from '../api';

export default function Benefits() {
  const [benefits, setBenefits] = useState([]);

  useEffect(() => {
    axios.get(API_BASE + '/benefits').then(r => setBenefits(r.data));
  }, []);

  return (
    <div>
      <nav className="navbar">
        <Link to="/" className="navbar-brand"><img src="/ustar-logo.png" alt="USTAR" /></Link>
        <div className="navbar-links">
          <Link to="/#register" className="nav-cta">הצטרף עכשיו ⭐</Link>
        </div>
      </nav>
      <div className="page-header">
        <h1>🎟️ הטבות המועדון</h1>
        <p>כחבר מועדון יוסטאר, כל ההטבות האלו זמינות עבורך</p>
      </div>
      <div className="page-content">
        <div className="pub-benefits-grid">
          {benefits.map(b => (
            <div key={b.id} className="pub-benefit-card">
              <div className="pub-cat">{b.category || 'כללי'}</div>
              <div className="pub-title">{b.title}</div>
              <div className="pub-desc">{b.description}</div>
              {b.discount && <span className="pub-discount">{b.discount}</span>}
            </div>
          ))}
        </div>
        {benefits.length === 0 && <p style={{color:'#666', textAlign:'center', marginTop:40}}>הטבות יתווספו בקרוב</p>}
        <div style={{textAlign:'center', marginTop:50}}>
          <Link to="/#register" className="btn btn-gold">הצטרף/י עכשיו וקבל גישה לכל ההטבות ⭐</Link>
        </div>
      </div>
      <div className="footer">
        <span>מועדון יוסטאר</span> — מועדון ההטבות לשחקני כדורגל צעירים
      </div>
    </div>
  );
}
